// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "TransactionRow__textCenter__4IrVp";
export const transactionRow = "TransactionRow__transactionRow__scK0D Table2__row__zROxA";
export const descriptionCell = "TransactionRow__descriptionCell__4yu+t";
export const tooltipIconWrapperOuter = "TransactionRow__tooltipIconWrapperOuter__stgjb";
export const tooltipIconWrapper = "TransactionRow__tooltipIconWrapper__WfRiL";
export const formRow = "TransactionRow__formRow__2GQ-U Table2__row__zROxA";
export const formRowCell = "TransactionRow__formRowCell__b1xCd";
export const dateWrapper = "TransactionRow__dateWrapper__QqsCU";
export const editButtonWrapper = "TransactionRow__editButtonWrapper__q2r5G";
export const categoryWrapper = "TransactionRow__categoryWrapper__FtAVi";
export const weekday = "TransactionRow__weekday__r-yTQ";